var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcComunidades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F36348E4-0262-4704-ABD9-C4C58DD9DCC2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -403.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-comunidades",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,1.9999094 L12.5,1.9999094 C11.0252097,1.99615482 9.56783025,2.34133179 8.24914664,3.00740197 C5.03486902,4.6138352 3.00139217,7.90201054 3.00000007,11.499613 L3.0062929,11.8679605 C3.04688751,12.9714727 3.28248792,14.0593261 3.70123475,15.080505 L3.824,15.365 L2.0513167,20.6837722 L2.02191665,20.7900492 C1.85842188,21.5310679 2.57000419,22.1974245 3.31622777,21.9486833 L8.635,20.175 L8.9195053,20.2987652 C10.0541999,20.7640394 11.2714656,21.0032065 12.5026073,20.9999966 C16.0979895,20.9986078 19.3861648,18.965131 20.9945046,15.7470587 C21.6586682,14.4321698 22.0038452,12.9747903 22.0000874,11.4974143 L22.0000874,11 C21.7372586,6.21053133 18.0212905,2.41073547 13.3221164,2.01995293 L13,1.9999094 Z M12.4974143,3.99996817 L12.958,3.999 L12.944908,3.99845279 C16.7517828,4.20850011 19.7914999,7.24821715 20.0015472,11.055092 L20.0000285,11.5 C20.0030374,12.6649757 19.7314558,13.8116265 19.207402,14.8491466 C17.9357535,17.3935246 15.3398256,18.9989011 12.499613,19.0000001 C11.3350271,19.003034 10.1883822,18.7314602 9.15085336,18.207402 L9.02896213,18.1556526 C8.82145802,18.0833645 8.59456045,18.081054 8.38377223,18.1513167 L4.58,19.419 L5.8486833,15.6162278 C5.93299858,15.3632819 5.91280832,15.0871386 5.79259803,14.8491466 C5.26853978,13.8116178 4.996966,12.6649729 4.9999966,11.5026073 C5.00109895,8.66017444 6.60647541,6.06424654 9.14705875,4.7945046 C10.1883735,4.26854418 11.3350243,3.99696259 12.4974143,3.99996817 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComunidades);
export default __webpack_public_path__ + "static/media/ic-comunidades.1008758f7a4a64451b5770b8dfaf352a.svg";
export { ForwardRef as ReactComponent };